//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TabelaGenerica from '../../../../../shared-components/generico/TabelaGenerica';
import { convertFloatToMoney } from '../../../../../common/functions/helpers';

export default {
  extends: TabelaGenerica,
  props: {
    mdOpenFrom: String,
  },
  methods: {
    defaultClose() {
      this.$emit('GENERICMODAL_DEFAULT_CLOSE');
      this.close();
    },
    getMoney(str) {
      str = convertFloatToMoney(String(str));
      str = str.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const money = str.split('.');
      return `${money[0].replace(/,/g, '.')},${money[1]}`;
    },
    open() {
      this.$refs.dialogRateio.open();
      this.onOpen();
    },
    onOpen() {
      this.$emit('GENERICMODAL_OPEN');
    },
    onClose() {
      this.$emit('GENERICMODAL_CLOSE');
    },
    close() {
      this.$refs.dialogRateio.close();
      this.onClose();
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/RateioModal.vue?vue&type=script&lang=js&